(function (scope) {
  'use strict';
  const EXPERIMENT = 'kmc-action-pack-v1';
  const ENABLED = false;
  const KEY = 'kmc:' + EXPERIMENT;
  const LIFETIME = 30 * 24 * 60 * 60 * 1000;
  const route = (href, base) => {
    const url = new URL(href);
    const root = new URL(base, url.origin).pathname.replace(/\/?$/, '/');
    if (!url.pathname.startsWith(root)) return null;
    const path = url.pathname.slice(root.length).replace(/\/$/, '');
    const product = /^(?:collections\/[^/]+\/)?products\/kmc-welcome-pack$/.test(path);
    const alternative = path === 'pages/new-customers-action-pack-v2' && url.searchParams.get('view') === 'action-pack-journey';
    return product || alternative ? {url, root, product, alternative} : null;
  };
  const preview = (url, shopify) => Boolean(shopify?.designMode || shopify?.inspectMode || shopify?.theme?.role && shopify.theme.role !== 'main' || ['preview_theme_id','preview_script_id','_fd','pb'].some(key => url.searchParams.has(key)));
  const destination = (entry, alternative) => {
    const url = new URL(entry.url);
    url.pathname = entry.root + (alternative ? 'pages/new-customers-action-pack-v2' : 'products/kmc-welcome-pack');
    if (alternative) url.searchParams.set('view', 'action-pack-journey');
    else if (url.searchParams.get('view') === 'action-pack-journey') url.searchParams.delete('view');
    return url.href;
  };
  const eligible = (entry, shopify, agent) => Boolean(entry && !preview(entry.url, shopify) && !/bot|crawler|spider|slurp|headless|lighthouse|facebookexternalhit|preview/i.test(agent || '') && !['selling_plan','fera','feraId','section_id','sections'].some(key => entry.url.searchParams.has(key)) && (!entry.product || !entry.url.searchParams.has('view')));
  const assignment = (storage, random, now, enroll) => {
    try {
      const raw = storage.getItem(KEY);
      if (raw) {
        try {
          const stored = JSON.parse(raw);
          if (stored.experiment === EXPERIMENT && ['A','B'].includes(stored.arm) && Number.isFinite(stored.expires) && stored.expires > now && stored.expires <= now + LIFETIME) return stored.arm;
        } catch (_) { }
      }
      if (!enroll) return null;
      const arm = random() < 0.5 ? 'A' : 'B';
      const record = JSON.stringify({experiment: EXPERIMENT, arm, expires: now + LIFETIME});
      storage.setItem(KEY, record);
      return storage.getItem(KEY) === record ? arm : null;
    } catch (_) { return null; }
  };
  const allowed = privacy => {
    try { return privacy?.preferencesProcessingAllowed() === true && privacy.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  };
  function install(window, document) {
    const node = document.querySelector('[data-kmc-ap-experiment]');
    if (!node) return;
    const base = node.dataset.root;
    let exposed = false, navigating = false;
    const start = () => {
      if (navigating) return;
      const entry = route(window.location.href, base);
      if (!entry) return;
      if (entry.alternative && entry.url.searchParams.has('selling_plan') && !window.Shopify?.designMode) {
        navigating = true;
        window.location.replace(destination(entry, false));
        return;
      }
      if (!ENABLED || !eligible(entry, window.Shopify, window.navigator.userAgent)) return;
      const process = () => {
        if (!allowed(window.Shopify?.customerPrivacy)) return;
        const current = route(window.location.href, base);
        if (!current || current.url.href !== entry.url.href || !eligible(current, window.Shopify, window.navigator.userAgent)) return;
        const random = () => { const bytes = new Uint32Array(1); window.crypto.getRandomValues(bytes); return bytes[0] / 4294967296; };
        let arm;
        try { arm = assignment(window.localStorage, random, Date.now(), entry.product); } catch (_) { return; }
        if (!arm) return;
        if (entry.product && arm === 'B') {
          navigating = true;
          window.location.replace(destination(entry, true));
          return;
        }
        if (entry.alternative && arm !== 'B') return;
        if (!exposed) {
          exposed = true;
          document.dispatchEvent(new window.CustomEvent('kmc:experiment-exposure', {detail: {experiment: EXPERIMENT, arm}}));
        }
      };
      if (window.Shopify?.customerPrivacy) process();
      else window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}], error => { if (!error) process(); });
    };
    start();
    window.addEventListener('pageshow', event => { if (event.persisted) { navigating = false; start(); } });
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {route, preview, destination, eligible, assignment, allowed, install, KEY, ENABLED};
  else install(scope, scope.document);
})(typeof window !== 'undefined' ? window : globalThis);
